module.exports = __webpack_public_path__ + "/bundle/asset/plan-1-f23cda311ac682d9c2546dc66c65b48c.png";